// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';

import './vue_hooks'; // This must be imported before any component
import './lib_import';
import 'bootstrap';
import * as Bluebird from 'bluebird';
import * as _ from 'lodash';
Promise = Bluebird as any;
import i18n from 'voo-i18n';

import App from '@/components/App.vue';
import router from './router';
import { ConfiguratorDefinition, parse } from '@/models/configuratorx/configuratorSchema';


import { Store } from '@/store';
import Axios from 'axios';

Vue.config.productionTip = process.env.NODE_ENV === 'production';

Axios.get('static/data/local.json').then((x) => { Vue.use(i18n, x.data); });

export let jsonBurositFormat = {};
Axios.get('static/data/productconfig.json').then((response) =>
{
  jsonBurositFormat = response.data;
});


new Vue({
  router,
  el: '#app',
  data: {
    state: Store.state,
    locale: 'tr',
    vmode: 'a3',
  },
  components: { App },
  template: '<App/>',
});






// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/main.ts